import { Component } from "@angular/core";

@Component({
  selector: "icon-ampliacion-seguro-documento",
  templateUrl: "./ampliacion-seguro-documento.svg",
  standalone: true,
})
export class AmpliacionSeguroDocumentoComponent {}